module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"HCC EAST AFRICAN HALAL CONFIRMATION CENTER LIMITED","short_name":"HCC EAST AFRICAN HALAL CONFIRMATION CENTER LIMITED","start_url":"/","description":"Halal certification services in Nairobi, Kenya and East Africa for exporters, slaughterhouses and food manufacturers.","background_color":"#663399","display":"minimal-ui","icon":"src/images/kenya.jpg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"fb44326072ba5dd8b0f5a975beefdc7d"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
